<template>
    <el-menu mode="vertical" :default-openeds="openeds" unique-opened :default-active="$route.path" background-color="#fff" active-text-color="#409EFF">
        <sidebar-item :routes='permission_routers'></sidebar-item>
    </el-menu>
</template>

<script>
import { mapGetters } from 'vuex';
import SidebarItem from './SidebarItem';
export default {
    components: { SidebarItem },
    computed: {
        ...mapGetters([
            'permission_routers',
            'sidebar'
        ]),
        isCollapse() {
            return !this.sidebar.opened
        }
    },
    data () {
        return {
          openeds: null,
        }
    },
    created() {
        if(localStorage.getItem('expandMenuName')){
            this.openeds = localStorage.getItem('expandMenuName').split(',');
        }else{
            this.openeds = null;
        }
    },
}
</script>

<style lang="scss" scoped>
    .el-menu {
        min-height: 100%;
    }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?a8bedc2a